<div class="confirm-payment-container">
    <div class="d-flex justify-content-between close-icon">
        <div class="btn-back" (click)="goBackModal()">
            <i class="fa-light fa-arrow-left" *ngIf="openedWhatsapp && !checkWhatsapp"></i>
            <span *ngIf="openedWhatsapp && !checkWhatsapp">Atrás</span>
        </div>
        <i class="fa-light fa-times pointer-in" (click)="goHome()"></i>
    </div>
    <!-- <p class="info-error" *ngIf="error">{{error}}</p> -->

    <div class="d-grid" *ngIf="!openedWhatsapp; else whatsappTemplate">
        <div class="icon-check-confirm">
            <i class="fa-light fa-circle-check"></i>
        </div>
        <p class="info-confirm">Tu compra se ha realizado correctamente.</p>

        <button class="btn btn-confirm-wahtsapp" (click)="openPrint()" *ngIf="idDownload">
            <i class="fa-light fa-file-arrow-down"></i>
            Descargar entradas
        </button>

        <button class="btn btn-whatsapp" (click)="openedWhatsapp = true" *ngIf="idDownload">
            <i class="fa-brands fa-whatsapp"></i>
            Envíamelas a Whatsapp
        </button>

        <p class="title-confirm">Gracias por confiar en Citylok</p>
    </div>
    <ng-template #whatsappTemplate>
        <div *ngIf="!checkWhatsapp; else whatsappConfirmTemplate">
            <div class="icon-check-confirm">
                <i class="fa-brands fa-whatsapp"></i>
            </div>
            <p class="info-confirm" *ngIf="!phonePrefilled">Completa tu número y te las enviamos por WhatsApp</p>
            <p class="info-confirm" *ngIf="phonePrefilled">Te las enviamos a este número. Si prefieres otro, cámbialo.</p>
            <div class="d-grid">
                <mat-form-field appearance="outline" class="whatsapp-input">
                    <i class="fa-brands fa-whatsapp whatsapp-icon-input" matPrefix></i>
                    <span class="whatsapp-prefix" matPrefix *ngIf="spanishNumber">+34</span>
                    <mat-label>Número de WhatsApp*</mat-label>
                    <input matInput type="tel" placeholder="Introduce tu número..." [ngModel]="numWhatsapp"
                        (ngModelChange)="onPhoneChange($event)">
                </mat-form-field>

                <button class="btn btn-confirm-wahtsapp" (click)="sendWhatsapp()">
                    Confirmar
                </button>
            </div>
        </div>
        <ng-template #whatsappConfirmTemplate>
            <div class="icon-check-confirm">
                <i class="fa-light fa-circle-check"></i>
            </div>
            <p class="info-confirm title-confirm-whatsapp">¡Hecho! te las hemos enviado por WhatsApp</p>
            <p class="info-whatsapp">Si no las has recibido puedes descargarlas <span class="link-download-tickets"
                    (click)="openPrint()">aquí.</span></p>
            <button class="btn btn-confirm-wahtsapp btn-close-whatsapp" (click)="goHome()">
                Gracias
            </button>
        </ng-template>
    </ng-template>
</div>